/**
 * Configuración del SPA. Lo que cambia por ambiente llega por VITE_* (build args en
 * producción, .docker/frontend/.env en dev); lo demás es de la aplicación.
 */

export const APP_NOMBRE = 'Administración'

/** Debe coincidir con APP_SLUG del backend. */
export const APP_SLUG: string = import.meta.env.VITE_APP_SLUG || 'administracion'

/** Ruta base del SPA: '/' (producción vive en la raíz de administracion.dcc.uchile.cl). */
export const SPA_BASE: string = import.meta.env.BASE_URL

const conBarra = (url: string) => (url.endsWith('/') ? url : `${url}/`)

/** Raíz de la API con / final: '/api/'. */
export const API_URL: string = conBarra(import.meta.env.VITE_API_URL || `${SPA_BASE}api`)

/** Raíz del backend (admin, hijack): la API sin el 'api/' final. */
export const BACKEND_URL: string = API_URL.replace(/api\/$/, '')

/** Cookie donde Django deja el token CSRF (CSRF_COOKIE_NAME = f"{APP_SLUG}_csrftoken"). */
export const CSRF_COOKIE = `${APP_SLUG}_csrftoken`

/** Carpeta del DCC UI Kit (CSS, fuentes y logos). */
export const UI_KIT_URL: string = __UI_KIT_URL__

export const LOGOS = {
  dccHorizontal: `${UI_KIT_URL}assets/logo-dcc-horizontal.svg`,
  dcc: `${UI_KIT_URL}assets/logo-dcc.svg`,
}

/**
 * Logos en color para documentos impresos (plancheta FOR-OAD-002). Los del kit son
 * blancos, para fondos oscuros, y su «fcfm» es el de la Escuela de Postgrado.
 */
export const LOGOS_IMPRESOS = {
  fcfm: `${SPA_BASE}logos/logo-fcfm.png`,
  dcc: `${SPA_BASE}logos/logo-dcc.png`,
}
